import React from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import type { IntlShape } from 'react-intl'
import playStore from 'shared/assets/images/play_store.png'
import appleStore from 'shared/assets/images/apple_store.png'
import { ImageButton } from 'app/common/image-button'
import styled from 'styled-components'
import { Link } from 'app/common/link'
import { media, style } from 'app/assets/styles'

type Props = {
    playStoreUrlKey: string,
    appleStoreUrlKey: string,
    linkUrl: string,
    buttonKey: string,
    color: string,
    icon?: any,
    handleClick?: () => void,
    intl: IntlShape
}

const StorePushComponent = (props: Props) => {
    const {
        linkUrl,
        playStoreUrlKey,
        appleStoreUrlKey,
        buttonKey,
        color,
        icon,
        intl,
        handleClick
    } = props
    return (
        <ButtonsContainer>
            {icon}
            <DeliveryButtonContainer>
                <StyledLink
                    url={linkUrl}
                    onClick={handleClick}
                    external
                    color={color}
                    background="none"
                    border={color}>
                    <FormattedMessage id={buttonKey} />
                </StyledLink>
            </DeliveryButtonContainer>
            <AppButtonsContainer>
                <ImageButton
                    url={intl.formatMessage({ id: playStoreUrlKey })}
                    image={playStore}
                />
                <ImageButton
                    url={intl.formatMessage({ id: appleStoreUrlKey })}
                    image={appleStore}
                />
            </AppButtonsContainer>
        </ButtonsContainer>
    )
}

const ButtonsContainer = styled.div`
    text-align: center;
    margin: 10px 5px;
    padding: 10px;
    border: solid 1px white;
    border-radius: 20px;
    ${media.medium`
       border: none;
       max-width: 40%;
    `};
`

const DeliveryButtonContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    margin: 10px 0 30px 0;
`

const StyledLink = styled(Link)`
    ${style.buttonLarge};
    display: flex;
    align-items: center;
    justify-content: center;
    height: 34px;
    padding: 2px 18px;
    width: 70%;
    max-width: 250px;
    font-size: 14px;
    ${media.medium`
        min-width: 150px;
        width: 40%;
        font-size: 18px;
    `};
`

const AppButtonsContainer = styled.div`
    display: inline-flex;
    width: 90%;
    max-width: 330px;
    flex-direction: ${props => (props.column ? 'column' : 'row')};
    justify-content: center;
    ${media.medium`
        flex-direction: row;
    `};
`

const StorePush = injectIntl(StorePushComponent)
export { StorePush }
